import { loader, text } from '@mage-ui/styled-system/recipes';

export const Loader = ({ texts }) => {
  return (
    <>
      <span className={loader()} aria-hidden='true' />
      <span
        aria-live='polite'
        className={text({ size: '5', weight: 'medium' })}
      >
        {texts.loading}
      </span>
    </>
  );
};
